import _find from 'lodash/find';
import angular from 'angular';

import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';
import defaultProfilePic from '../../assets/images/placeholder-user.png';

function TeamServerEditCtrl($scope, $q, $state, $stateParams, $timeout, venueService, sdkUtils, utilsService, managementUserService, alertService, organizationService, organizationMemberService, formHelpersService, ERROR_MESSAGES, loggerService, organizationPermissionService, sdkPermissionService, permissionService, TRACKING_EVENT_CATEGORIES, analyticsService, notificationSettingService) { //eslint-disable-line
  const currentUserOrganization = organizationService.getCurrentOrganization();
  const currentUser = managementUserService.getCurrentUser();
  const staffMemberId = $stateParams.id;

  _initScope();

  _getVenues()
    .then(() => {
      if (!$scope.editMode) {
        return null;
      }

      return _getStaffMember();
    })
    .then(() => {
      if (!$scope.editMode) {
        $scope.staffMemberForm = {
          enable: true
        };
      }
    })
    .finally(() => {
      $scope.loading = false;
    });

  $scope.nextSection = function(form, $event) {
    if ($event) $event.preventDefault();
    if (!form) return null;

    $scope.submitted = true;

    if (!form.$valid) {
      $scope.errors = formHelpersService.getFormErrors(form);
      return null;
    }

    return null;
  };

  function _initScope() {
    $scope.loading = true;
    $scope.staffMemberForm = {};
    $scope.editMode = staffMemberId ? true : false; //eslint-disable-line
    $scope.saveStaffMember = _saveStaffMember;
    $scope.defaultProfilePic = defaultProfilePic;
  }

  function _getVenues() {
    return venueService.listByOrganizationId(currentUserOrganization.id, {
        fields: [
          'name',
          'id',
          'nightProId'
        ].join(',')
      })
      .then(venues => {
        $scope.venues = venues;
      })
      .catch(response => _handleError(response, ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_VENUES));
  }

  function _getStaffMember() {
    return organizationMemberService.readByIdAndOrganizationId(staffMemberId, currentUserOrganization.id)
      .then(staffMember => {
        staffMember.venues = (staffMember.venues || []).map(venueId => {
          return _find($scope.venues, {
            _id: venueId
          });
        });

        $scope.staffMember = staffMember;
        $scope.isCurrentUser = $scope.staffMember.managementUser === currentUser.id;
        $scope.staffMemberForm = _mapStaffDataToForm();
      })
      .catch(response => {
        if (response && response.status !== 404) {
          _handleError(response, ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_STAFF_BY_ID);
        }
      });
  }

  /**
   * @desc Create or update a staff member
   * @param {Object} form - Angular form object
   * @param {Object} [$event] - Angular event object
   */
  function _saveStaffMember(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    $scope.submitted = true;
    $scope.errors = [];

    if (!form.$valid) {
      $scope.errors = formHelpersService.getFormErrors(form);
      return null;
    }

    const staffCreateOrUpdateData = _mapChangedFormValuesToApiData(form);
    staffCreateOrUpdateData.type = 'SERVER';

    $scope.savingStaffMember = true;

    let createOrUpdateStaffMemberPromise;

    if ($scope.editMode) {
      createOrUpdateStaffMemberPromise = organizationMemberService.updateByIdAndOrganizationId(staffMemberId, currentUserOrganization.id, staffCreateOrUpdateData);
    } else {
      createOrUpdateStaffMemberPromise = organizationMemberService.createByOrganizationId(currentUserOrganization.id, staffCreateOrUpdateData);
    }

    return createOrUpdateStaffMemberPromise
      .then(staffMember => {
        $scope.staffMember = staffMember;

        alertService.success(`Staff member ${$scope.editMode ? 'updated' : 'created'}`);

        if (!$scope.editMode) {
          _trackStaffMemberCreated();
        }
      })
      .then(() => {
        $state.go('app.organization.settings.servers');
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      })
      .finally(() => {
        $scope.savingStaffMember = false;
      });
  }

  function _mapChangedFormValuesToApiData(form) {
    if (!form) return null;

    let changedValues;
    const staffData = {};

    if (!$scope.editMode) {
      changedValues = angular.copy($scope.staffMemberForm);
    } else {
      changedValues = formHelpersService.getChangedFormValues(form);
    }

    if ('firstName' in changedValues) staffData.firstName = changedValues.firstName;
    if ('lastName' in changedValues) staffData.lastName = changedValues.lastName;
    if ('email' in changedValues) staffData.email = changedValues.email;
    if ('phone' in changedValues) staffData.phone = changedValues.phone ? changedValues.phone.toString() : null;
    if ('title' in changedValues) staffData.title = changedValues.title ? changedValues.title.toString() : null;
    if ('profileImage' in changedValues) staffData.profileImage = changedValues.profileImage;
    if ('enable' in changedValues) staffData.enable = changedValues.enable;
    if ('venues' in changedValues) staffData.venueIds = changedValues.venues && changedValues.venues.length ? changedValues.venues.map(v => v.id) : [];

    return staffData;
  }

  /**
   * @desc Maps the $scope.venue to an object the UI will bind to
   * @return Object
   */
  function _mapStaffDataToForm() {
    let staffEditData = {};

    staffEditData = angular.copy($scope.staffMember);

    if (staffEditData.phone) staffEditData.phone = parseInt(staffEditData.phone, 10);

    return staffEditData;
  }

  function _handleError(response, type) {
    const errorMsg = sdkUtils.getErrorFromResponse(response);
    if (errorMsg) loggerService.error(errorMsg);
    alertService.fatalError(type);
  }

  function _trackStaffMemberCreated() {
    analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.CREATED_STAFF_MEMBER, {
      category: TRACKING_EVENT_CATEGORIES.STAFF_MEMBERS
    });
  }
}

TeamServerEditCtrl.$inject = [
  '$scope',
  '$q',
  '$state',
  '$stateParams',
  '$timeout',
  'jsSdk.venue',
  'jsSdk.utils',
  'utilsService',
  'jsSdk.managementUser',
  'alertService',
  'organizationService',
  'jsSdk.organizationMember',
  'formHelpersService',
  'ERROR_MESSAGES',
  'loggerService',
  'jsSdk.organizationPermission',
  'jsSdk.permission',
  'permissionService',
  'TRACKING_EVENT_CATEGORIES',
  'analyticsService',
  'jsSdk.notificationSetting'
];

export default TeamServerEditCtrl;



// WEBPACK FOOTER //
// ./src/components/teamServerEdit/teamServerEditCtrl.js